const BLACK_LIST_AFFILIATE_IDS = ['7654'];

export const isFasReviewer = (url: string) =>
    url.startsWith('/zaimy/special/affho/') && BLACK_LIST_AFFILIATE_IDS.some((id) => url.includes(id));
